import type { Worker } from "@src/appV2/Worker/api/types";
import { uniq } from "lodash";

export const getWorkerQualifications = (worker: Worker): string[] => {
  if (!worker?.licensesData?.length) {
    return [];
  }
  const qualifications: string[] = [];
  for (const data of worker.licensesData) {
    qualifications.push(data.qualification);
  }
  return uniq(qualifications);
};

export const formatQualificationsForProfile = (qualifications: string[]): string => {
  if (qualifications.length === 0) {
    return "";
  }

  if (qualifications.length <= 3) {
    return qualifications.join(", ");
  }

  const firstThree = qualifications.slice(0, 3);
  const remainingCount = qualifications.length - 3;
  return `${firstThree.join(", ")} and ${remainingCount} more`;
};
